import LoginBackOffice from './login';

export default LoginBackOffice;
